import React from 'react';
import PropTypes from 'prop-types';
import Select from './Select';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { enumToSelectOptions } from '../../../../utils/enum';
import { CONTRACT_TYPE } from '../../../../config/constants';
import SelectFilter from '../../filters/SelectFilter';

const AgencyContractTypeSelect = ({
  noOptionsMessage,
  input,
  meta,
  isDisabled,
  useForFilter,
  onChangeFilter,
  ...rest
}) =>
  useForFilter ? (
    <SelectFilter
      options={enumToSelectOptions(CONTRACT_TYPE)}
      onChangeFilter={onChangeFilter}
    />
  ) : (
    <Select
      options={enumToSelectOptions(CONTRACT_TYPE)}
      noOptionsMessage={noOptionsMessage}
      input={input}
      meta={meta}
      isDisabled={isDisabled}
      {...rest}
    />
  );
AgencyContractTypeSelect.propTypes = {
  noOptionsMessage: PropTypes.func,
  input: inputPropTypes,
  meta: metaPropTypes,
  isDisabled: PropTypes.bool,
  useForFilter: PropTypes.bool,
  onChangeFilter: PropTypes.func,
};

AgencyContractTypeSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  noOptionsMessage: undefined,
  isDisabled: false,
  useForFilter: false,
  onChangeFilter: () => {},
};

export default AgencyContractTypeSelect;
